import React from 'react';

const Homepage = () => {
    return (
        <>Homepage</>
    )
};

export default Homepage;